import type { ReactNode } from 'react';

import { create } from 'zustand';

interface PageActionsState {
  primary: (() => ReactNode) | null;
  secondary: (() => ReactNode) | null;
  setPrimary: (action: (() => ReactNode) | null) => void;
  setSecondary: (action: (() => ReactNode) | null) => void;
  setActions: (primary: (() => ReactNode) | null, secondary: (() => ReactNode) | null) => void;
  clearActions: () => void;
}

export const usePageActionsStore = create<PageActionsState>((set) => ({
  primary: null,
  secondary: null,
  setPrimary: (action) => set({ primary: action }),
  setSecondary: (action) => set({ secondary: action }),
  setActions: (primary, secondary) => set({ primary, secondary }),
  clearActions: () => set({ primary: null, secondary: null }),
}));
